<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Sales
            Navigator campaign</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <!--          <div class="col-lg-6 col-5 text-right">-->
        <!--            <base-button size="sm" type="neutral">New</base-button>-->
        <!--            <base-button size="sm" type="neutral">Filters</base-button>-->
        <!--          </div>-->
      </div>

    </base-header>


    <div v-if="this.$store.getters.getHaveAccount" class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <card>
            <add-new-configuration-sales-linkedin/>
          </card>
        </div>
      </div>
    </div>
    <div v-else class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <card>
            <add-user-credentials/>
          </card>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    import AddNewConfigurationSalesLinkedin
        from "../components/ysy/AddNewConfigurationSalesLinkedin";
    import {mdbCol, mdbContainer, mdbRow} from 'mdbvue';
    import AddUserCredentials from "../components/addUserCredentials";
    import RouteBreadCrumb from '../components/Argon/Breadcrumb/RouteBreadcrumb';

    export default {
        name: "setUserConfigurationSalesNavigator",
        components: {
            AddUserCredentials,
            mdbContainer,
            RouteBreadCrumb,
            AddNewConfigurationSalesLinkedin,
            mdbRow,
            mdbCol

        },
        data() {
            return {
                componentKey: 0
            }
        },
        methods: {
            forceRerender() {
                this.componentKey += 1
            }
        }
    }
</script>

<style scoped>

  .config-col {
    width: 100%;
    max-width: 100%;
    height: 100%;
    padding-right: 50px;
  }

  .my-sidebar {
    -ms-flex: 0 0 230px;
    flex: 0 0 230px;

  }

  @media (max-width: 720px) {
    .set-configuration-container {
      position: absolute;
      margin-left: 10px;
    }
  }

</style>
